const prefix = '@@publications/';

export const FETCH_PUBLICATIONS_PAGE = `${prefix}FETCH_PUBLICATIONS_PAGE`;
export const FETCH_PUBLICATIONS_PAGE_SUCCESS = `${prefix}FETCH_PUBLICATIONS_PAGE_SUCCESS`;
export const FETCH_PUBLICATIONS_PAGE_ERROR = `${prefix}FETCH_PUBLICATIONS_PAGE_ERROR`;
export const FETCH_PUBLICATIONS_BY_YEARS_PAGE_SUCCESS = `${prefix}FETCH_PUBLICATIONS_BY_YEARS_PAGE_SUCCESS`;

export const FETCH_PUBLICATIONS_BY_THEME_PAGE = `${prefix}FETCH_PUBLICATIONS_BY_THEME_PAGE`;
export const FETCH_PUBLICATIONS_BY_THEME_PAGE_SUCCESS = `${prefix}FETCH_PUBLICATIONS_BY_THEME_PAGE_SUCCESS`;
export const FETCH_PUBLICATIONS_BY_THEME_PAGE_ERROR = `${prefix}FETCH_PUBLICATIONS_BY_THEME_PAGE_ERROR`;

export const FETCH_PUBLICATIONS_BY_RESEARCHER_PAGE = `${prefix}FETCH_PUBLICATIONS_BY_RESEARCHER_PAGE`;
export const FETCH_PUBLICATIONS_BY_RESEARCHER_PAGE_SUCCESS = `${prefix}FETCH_PUBLICATIONS_BY_RESEARCHER_PAGE_SUCCESS`;
export const FETCH_PUBLICATIONS_BY_RESEARCHER_PAGE_ERROR = `${prefix}FETCH_PUBLICATIONS_BY_RESEARCHER_PAGE_ERROR`;

export const FETCH_PUBLICATION = `${prefix}FETCH_PUBLICATION`;
export const FETCH_PUBLICATION_SUCCESS = `${prefix}FETCH_PUBLICATION_SUCCESS`;
export const FETCH_PUBLICATION_ERROR = `${prefix}FETCH_PUBLICATION_ERROR`;

export const FETCH_PUBLICATION_YEARS = `${prefix}FETCH_PUBLICATION_YEARS`;
export const FETCH_PUBLICATION_YEARS_SUCCESS = `${prefix}FETCH_PUBLICATION_YEARS_SUCCESS`;
export const FETCH_PUBLICATION_YEARS_ERROR = `${prefix}FETCH_PUBLICATION_YEARS_ERROR`;
